export default class pegFooter extends HTMLElement {
	async connectedCallback() {
		await jPar.util.waitForChildNodes();
	}

	disconnectedCallback() {}
}
